import React from "react";
import { Box, Paper, Skeleton, Stack, Text, ThemeIcon } from "@mantine/core";
import {
  IconCalendarEvent,
  IconClock,
  IconCurrencyDollar,
  IconHourglass,
} from "@tabler/icons-react";
import { formatCost, formatDuration } from "./meetingDistUtils";

const Metric = ({ icon, color, label, value, isLoading }) => (
  <Box
    sx={(theme) => ({
      flex: 1,
      minWidth: 0,
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "12px 16px",
      "&:not(:first-of-type)": {
        borderLeft: `1px solid ${theme.colors.gray[2]}`,
      },
    })}
  >
    <ThemeIcon size={34} radius="md" variant="light" color={color}>
      {icon}
    </ThemeIcon>
    <Stack spacing={2} sx={{ minWidth: 0 }}>
      <Text
        size={11}
        weight={600}
        color="dimmed"
        transform="uppercase"
        sx={{ letterSpacing: "0.5px", lineHeight: 1.2, whiteSpace: "nowrap" }}
      >
        {label}
      </Text>
      {isLoading ? (
        <Skeleton height={20} width={56} />
      ) : (
        <Text
          size={20}
          weight={700}
          sx={{ lineHeight: 1.15, fontVariantNumeric: "tabular-nums" }}
        >
          {value}
        </Text>
      )}
    </Stack>
  </Box>
);

const MeetingDistSummary = ({ insights, isLoading }) => (
  <Paper withBorder radius="md" sx={{ overflow: "hidden" }}>
    <Box sx={{ display: "flex", flexWrap: "wrap" }}>
      <Metric
        icon={<IconCalendarEvent size={18} />}
        color="indigo"
        label="Meetings"
        value={insights.totalMeetings}
        isLoading={isLoading}
      />
      <Metric
        icon={<IconClock size={18} />}
        color="blue"
        label="Total time"
        value={formatDuration(insights.totalDuration)}
        isLoading={isLoading}
      />
      <Metric
        icon={<IconHourglass size={18} />}
        color="teal"
        label="Avg time"
        value={formatDuration(insights.averageDuration)}
        isLoading={isLoading}
      />
      <Metric
        icon={<IconCurrencyDollar size={18} />}
        color="yellow"
        label="Avg cost"
        value={insights.averageCost > 0 ? formatCost(insights.averageCost) : "N/A"}
        isLoading={isLoading}
      />
    </Box>
  </Paper>
);

export default MeetingDistSummary;
